<template>
  <section class="content">
    <div class="block-header">
      <div class="row">
        <div class="col-lg-7 col-md-6 col-sm-12">
          <h2>داشبورد</h2>
          <ul class="breadcrumb mt-3">
            <li class="breadcrumb-item">
              <a href="#">
                <i class="zmdi zmdi-home"></i>
                <span style="margin-right: 5px;">پنل مدیریت</span>
              </a>
            </li>
            <!-- <li class="breadcrumb-item active">داشبورد 1</li> -->
          </ul>
<!--          <button class="btn btn-primary btn-icon mobile_menu" type="button">
            <i class="zmdi zmdi-sort-amount-desc"></i>
          </button>-->
        </div>
        <div class="col-lg-5 col-md-6 col-sm-12">
          <button class="btn btn-primary btn-icon float-right" type="button" @click="$store.state.menuShow=true">
            <i class="zmdi zmdi-menu align-middle"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row clearfix">

        <div class="col-lg-3 col-md-6 col-sm-12">

          <div class="card widget_2">
            <a href="OrderManagementNew">
              <div class="body">

                <h6>سفارشات</h6>
                <h2>
                  {{ postCount }}
                  <!-- <small class="info">100</small> -->
                </h2>
<!--                 <small>50 تا بالاتر از ماه گذشته</small>-->
                <!-- <div class="progress">
                  <div
                    class="progress-bar l-amber"
                    role="progressbar"
                    aria-valuenow="45"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 45%;"
                  ></div>
                </div>-->
              </div>
            </a>

          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="card widget_2">
            <a href="InvoiceNotes">
              <div class="body">
                <h6>یادداشت‌ها</h6>
                <h2>
                  {{ messageCount }}
                  <!-- <small class="info">از 100</small> -->
                </h2>
                <!-- <small>0تا بالاتر از ماه گذشته</small> -->
                <!--<div class="progress">
                  <div
                    class="progress-bar l-blue"
                    role="progressbar"
                    aria-valuenow="38"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 38%;"
                  ></div>
                </div>-->
              </div>
            </a>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="card widget_2">
            <a href="ReportList">
              <div class="body">
                <h6>مرور گزارش‌ها</h6>
                <h2>
                  {{ messageCount }}
                  <!-- <small class="info">از 100</small> -->
                </h2>
                <!-- <small>0تا بالاتر از ماه گذشته</small> -->
                <!--<div class="progress">
                  <div
                    class="progress-bar l-blue"
                    role="progressbar"
                    aria-valuenow="38"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 38%;"
                  ></div>
                </div>-->
              </div>
            </a>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="card widget_2">
            <a href="UserList">
              <div class="body">
                <h6>کاربران</h6>
                <h2>
                  0
                  <!-- <small class="info">از 100</small> -->
                </h2>
                <!-- <small>0تا بالاتر از ماه گذشته</small> -->
                <!--<div class="progress">
                  <div
                    class="progress-bar l-blue"
                    role="progressbar"
                    aria-valuenow="38"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 38%;"
                  ></div>
                </div>-->
              </div>
            </a>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="card widget_2">
            <a href="CustomerClub">
              <div class="body">
                <h6>باشگاه مشتریان</h6>
                <h2>
                  0
                  <!-- <small class="info">از 100</small> -->
                </h2>
                <!-- <small>0تا بالاتر از ماه گذشته</small> -->
                <!--<div class="progress">
                  <div
                    class="progress-bar l-blue"
                    role="progressbar"
                    aria-valuenow="38"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 38%;"
                  ></div>
                </div>-->
              </div>
            </a>
          </div>
        </div>
<!--        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="card widget_2 big_icon traffic">
            <div class="body">
              <h6>کاربران</h6>
              <h2>
                {{ userCount }}
              </h2>
            </div>
          </div>
        </div>-->
<!--        <div class="col-lg-3 col-md-6 col-sm-12">
          <div class="card widget_2 big_icon traffic">
            <div class="body">
              <h6>نظرات جدید</h6>
              <h2>
                {{ commentCount }}
              </h2>
            </div>
          </div>
        </div>-->
      </div>
<!--      <div class="row">
        <div class="col-lg-12">
          <div>
            <apexchart width="100%" type="bar" :options="chartOptions" :series="series"></apexchart>
          </div>
        </div>

      </div>-->
    </div>
  </section>
</template>
<script>
/* eslint-disable */
import axios from "axios";
//import VueApexCharts from 'vue-apexcharts';

export default {
  name: "Dashboard",
  data() {
    return {
      messageCount: 0,
      commentCount: 0,
      postCount: 0,
      userCount: 0,
      options: {
        chart: {
          id: 'vuechart-example'
        },
        xaxis: {
          categories: ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنج شنبه', 'جمعه']
        }
      },
      factorData: {
        TotalSales: [],
        AppCreditSales: [],
        AppWalletSales: [],
        PosSales: [],
        WalletTransactionCount: [],
        CreditTransactionCount: []
      }
      ,
      series: [{
        data: []
      }],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 380
        },
        plotOptions: {
          bar: {
            barHeight: '100%',
            distributed: false,
            horizontal: false,
            dataLabels: {
              position: 'bottom'
            },
          }
        },
        colors: ['#33b2df', '#33b2df', '#33b2df', '#33b2df', '#33b2df', '#33b2df', '#33b2df'],
        dataLabels: {
          enabled: false,
          textAnchor: 'start',
          style: {
            colors: ['#000']
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + "jjjj"
          },
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه'],
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        title: {
          text: 'فروش هفته جاری',
          align: 'center',
          floating: true
        },

        tooltip: {
          theme: 'dark',
          x: {
            show: true
          },
          y: {
            title: {
              formatter: null
            },
            formatter: function () {
              return ''
            }
          },
          style: {
            fontSize: '12px',
            fontFamily: "IRANSansDN",
          }
        }
      },


    };
  },
  methods: {
    getDashboardInfo() {
      var self = this;
      var userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      //self.postCategories = [];
      //self.postField.Tags = [];
      axios
          .get("/GetDashboardInfo", {
            headers: {
              authorization: userInfo.Token
            }
          })
          .then(function (response) {
            console.log("Dashboard", response.data);
            if (response.data.Status === 1) {
              let result = response.data.Data;
              self.factorData = result.Factors;
              self.series[0].data = self.factorData.TotalSales;
              self.messageCount = result.MessageCount;
              self.postCount = result.PostCount;
              self.commentCount = result.CommentCount;
              self.userCount = result.UserCount;
            }
          })
          .catch(function (error) {
          });
    }
  },
  created() {
    let self = this;
    /*self.getDashboardInfo();
    this.chartOptions.tooltip.y.title.formatter = function (val, opt) {
      return "فروش بانکی اعتباری: " + self.factorData.PosSales[opt.dataPointIndex].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "<br>" + "فروش اپ اعتباری: " + self.factorData.AppCreditSales[opt.dataPointIndex].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+"<br>"+ "فروش اپ نقدی: " + self.factorData.AppWalletSales[opt.dataPointIndex].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "<br>"+"مبلغ کل فروش:"+self.factorData.TotalSales[opt.dataPointIndex].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+"<br>" + "تعداد کل تراکنش های اعتباری:" + self.factorData.CreditTransactionCount[opt.dataPointIndex]+"<br>" + "تعداد کل تراکنش های نقدی:" + self.factorData.WalletTransactionCount[opt.dataPointIndex]
    }*/
  },
  updated() {
    let self = this;

  },
  computed: {},
  components: {
    //'apexchart': VueApexCharts
  }
};
</script>
<style>
/* @import '../../public/assets/plugins/charts-c3/plugin.css';
@import '../../public/assets/plugins/morrisjs/morris.min.css'; */
</style>
